import React, { useState } from "react";

const Filter = ({ selected, setSelected, options }) => {
	const [open, setOpen] = useState(false);
	const [hovered, setHovered] = useState(-1);
	const handleClick = (option) => {
		setOpen(false);
		setSelected(option);
		setHovered(-1);
	};
	const handleHover = (i) => {
		setHovered(i);
	};

	return (
		<div className='relative cursor-pointer flex flex-col justify-center items-center text-xs sm:text-base min-w-[120px] max-w-[1200px] sm:w-[120px] md:w-[250px]'>
			<div
				onClick={() => setOpen(!open)}
				className='text-textSecondaryColor flex justify-between py-1 items-center rounded-lg w-full  px-3 bg-gradient-to-r from-white to-[#D9D9D9]'>
				<img src={"/assets/noun_filter.png"} alt='filter' />
				<span className='text-right'>{selected}</span>
			</div>
			{open && (
				<div className='absolute top-8 z-10 rounded-lg mt-1 w-full text-textSecondaryColor'>
					{options.map((option, i) => (
						<div
							onMouseEnter={() => handleHover(i)}
							key={i}
							onClick={() => handleClick(option)}
							className={`flex ${
								i === 0 ? "rounded-t-lg pt-1" : "rounded-none"
							} ${
								i === options.length - 1 ? "rounded-b-lg pb-1" : "rounded-none"
							} w-full relative justify-between pl-3 items-center gap-2 pr-4 bg-[#EDEDED] text-right`}>
							<img
								className={`-rotate-90 ${
									selected === option ? "opacity-100" : "opacity-0"
								}`}
								src={"/assets/noun_filter.png"}
								alt='filter'
							/>
							<div
								className={`flex ${
									hovered === i ? "bg-[#D9D9D9]" : ""
								} rounded-md items-center py-[6px] justify-center`}>
								<span className='whitespace-normal sm:whitespace-nowrap text-right right-0 px-[5px]'>
									{option}
								</span>
								{
									<div
										className={`w-[3px] ${
											selected === option
												? "opacity-100"
												: hovered === i
												? "opacity-50"
												: "opacity-0"
										} h-5 bg-textSecondaryColor rounded-md`}></div>
								}
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default Filter;
